












import { Vue, Component } from 'vue-property-decorator'
import Introduction from '../components/Introduction.vue'
// import Carousel from '../components/Carousel.vue'
import MarketingPoints from '../components/MarketingPoints.vue'
import LessonContents from '../components/LessonContents.vue'
import FunctionList from '../components/FunctionList.vue'
import AdultKidsTabs from '../components/AdultKidsTabs.vue'
import MediaCoverage from '../components/MediaCoverage.vue'
import FAQSection from '../components/FAQSection.vue'

@Component({
    components: {
        Introduction,
        // Carousel,
        MarketingPoints,
        LessonContents,
        FunctionList,
        AdultKidsTabs,
        MediaCoverage,
        FAQSection,
    },
})
export default class Landing extends Vue {}
